import { render, staticRenderFns } from "./login-input.component.vue?vue&type=template&id=06cc9805&scoped=true"
import script from "./login-input.component.vue?vue&type=script&lang=ts"
export * from "./login-input.component.vue?vue&type=script&lang=ts"
import style0 from "./login-input.component.vue?vue&type=style&index=0&id=06cc9805&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06cc9805",
  null
  
)

export default component.exports